import "react-app-polyfill/stable";
import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { initI18N } from "i18n";
import { Spinner } from "component-library";
import { IApplicationState } from "store";

import { Root } from "app-shell/Root/Root";

import configureStore from "./app/store/configureStore";
import "./index.css";

const store = configureStore({} as IApplicationState);

initI18N(["agent"]);

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);

root.render(
  <Suspense fallback={<Spinner />}>
    <Root store={store} />
  </Suspense>
);
